module.exports = __webpack_public_path__ + "static/media/bindOutlook1.7f0b1bec.png";